module.exports = __webpack_public_path__ + "static/media/clock.4fa73e97.svg";